import fetch from "../components/Fetchinterceptor/FetchInterceptor";


const galleryService = {}
const apiRoute = '/image';

galleryService.getAll = async function (query = '') {
    try {
        const res = await fetch({
            url: `${apiRoute}/getAll/public${query}`,
            method: 'get'
        });
        return res;
    } catch (err) {
        console.log(err, 'show-err');
        return err
    }
}


galleryService.getBySlug = async function (slug) {
    try {
        const res = await fetch({
            url: `${apiRoute}/get/slug/public/${slug}`,
            method: 'get',
        })
        return res
    } catch (err) {
        return err
        console.log(err, 'show-err')
    }
}

export default galleryService;